module.exports = __webpack_public_path__ + "static/img/skeleton.efec4e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/skeleton.png
// module id = XWLA
// module chunks = 1